import { post, get } from "@/api/axios.js"; // 引入axios封装方法

export function Login(account, password, googleAuth) {
  let datas = {
    account: account,
    password: password,
    googleAuth: googleAuth
  };
  let e = post("/login", datas);
  return e;
}
export function LoginMath(account, password, googleAuth) {
  let datas = {
    account: account,
    password: password,
    googleAuth: googleAuth
  };
  let e = post("/loginmath", datas);
  return e;
}

export function BindCall(
  s401account,
  IDname,
  IDcode,
  phone,
  token,
  refreshtoken,
  s401type
) {
  let datas = {
    account: s401account,
    IDname: IDname,
    IDcode: IDcode,
    phone: phone,
    token: token,
    refreshtoken: refreshtoken,
    s401type: s401type
  };
  let e = post("/bindIDInfo", datas);
  return e;
}

export function GetHistoryCallRecordsWithDateTime(
  personID,
  dateStart,
  dateEnd
) {
  let datas = {
    personID: personID,
    dateStart: dateStart,
    dateEnd: dateEnd
  };
  let e = get("/getHistoryCallRecordsWithDateTime", datas);
  return e;
}

export function GetBillsInfoWithCrmID(crmid) {
  let datas = {
    crmid: crmid
  };
  let e = get("/getBillsInfoWithCrmID", datas);
  return e;
}
export function GetCallHistoryWithCrmID(crmid) {
  let datas = {
    crmid: crmid
  };
  let e = get("/getCallHistoryWithCrmID", datas);
  return e;
}
export function DoubleCallWithPhone(phone) {
  let datas = {
    phone: String(phone),
    type: "phone"
  };
  let e = post("/doubleCall", datas);
  return e;
}
export function DoubleCallWithCrmID(crmid) {
  let datas = {
    crmid: String(crmid),
    type: "crmid"
  };
  let e = post("/doubleCall", datas);
  return e;
}
export function DoubleCallWithMathCrmID(crmid) {
  let datas = {
    crmid: String(crmid),
    type: "crmid"
  };
  let e = post("/doubleCallMath", datas);
  return e;
}
export function SendSMS(param) {
  let e = post("/sendSMS", param);
  return e;
}
export function GetCallSetting() {
  let e = get("/getCallSetting");
  return e;
}
export function ChangeCallTelA(phone) {
  let param = {
    phone: phone
  };
  return post("/changeCallTelA", param);
}
export function SelectCallTelX(phone) {
  let param = {
    phone: phone
  };
  return post("/selectCallTelA", param);
}
export function ChangeTelAWithArea(areacode, type) {
  let param = {
    areacode: areacode,
    type: type
  };
  return post("/ChangeTelAWithArea", param);
}
export function GetPersonsList() {
  return get("/getPersonsList");
}
export function GetReportDashboard(dateStart, dateEnd) {
  let param = {
    dateStart: dateStart,
    dateEnd: dateEnd
  };
  return get("/getReportDashboard", param);
}
export function RefreshToken() {
  let param = {
    token: localStorage.token,
    personID: localStorage.personID,
    s401type: localStorage.s401type
  };
  return post("/refreshToken", param);
}

export function SendLoginSMSCode(phone) {
  let param = {
    phone: phone
  };
  return get("/getLoginSMSCode", param);
}
export function CheckLoginSMSCode(phone, code) {
  let param = {
    phone: phone,
    code: code
  };
  return post("/checkLoginSMSCode", param);
}
export function GetRecordHistoryWithPhoneOrID(type, text) {
  let param = {
    type: type,
    text: text
  };
  return get("/getRecordWithPhoneOrID", param);
}
export function GetBoundAdmins(code) {
  return get("/dinglogin_boundAdmins?code=" + code);
}
export function LoginByDingTalk(code, adminId) {
  let param = {
    code: code,
    adminId: adminId
  };
  return post("/dinglogin_loginByDingTalk", param);
}
export function GetSMSSendHistoryWithPersonID(personID, dateStart, dateEnd) {
  let param = {
    personID: personID,
    dateStart: dateStart,
    dateEnd: dateEnd
  };
  return get("/getSmsInfoList", param);
}
